export default __webpack_public_path__ + "static/media/Line.66633221.svg";